import {Box, ListItem, ListItemIcon, ListItemText} from "@mui/material";
import {useState} from "react";

const SideNavItem = ({text, active, activeIcon, icon, hidden, isMiniNav}) => {
  const [showActive, setShowActive] = useState(false);

  return (
      <ListItem
          onMouseEnter={() => setShowActive(true)}
          onMouseLeave={() => setShowActive(false)}
          sx={{display: hidden ? "none" : "flex",
        justifyContent: "center",
        cursor: "pointer",
        mr: "5px",
        marginTop: "12px",
        width: isMiniNav ? "40px" : "100%",
        height: "40px", padding: "0",
        borderRadius: "6px",
        color: active ? "white" : "",
        background: active ? "#7F00FF" : '',
        "&.MuiListItem-root:hover": {
          background: active ? "" : '#dec7f6',
          color: active ? '' : "white"
          , "& .MuiSvgIcon-fontSizeMedium" : {
            color: "white"
          }
        }
      }}>
        <ListItemIcon  sx={{minWidth: 0,
          paddingRight: "3px",
          paddingLeft: isMiniNav ? 0 : "10px", "& .MuiSvgIcon-fontSizeMedium" : {
            color: active ? "white" : ''
          }}}>
          {active || showActive ? activeIcon : icon}
        </ListItemIcon>
        <ListItemText style={{display: isMiniNav ? 'none' : 'flex', justifyContent:'flex-start', fontWeight: 700, fontSize: "14px"}} primary={text} />
      </ListItem>
  );
}

export default SideNavItem;
